module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "600px",
      "border": "1px solid #EEEEEE",
      "background": "#FFFFFF"
    }
  }, [_c('el-tabs', {
    staticClass: "orderList-el-tabs",
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.AllLoading),
      expression: "AllLoading"
    }],
    attrs: {
      "label": "aaa",
      "name": "allOrder"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.AllLoading),
      expression: "AllLoading"
    }],
    attrs: {
      "label": "bbb",
      "name": "allOrder"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.AllLoading),
      expression: "AllLoading"
    }],
    attrs: {
      "label": "dddd",
      "name": "allOrder"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.AllLoading),
      expression: "AllLoading"
    }],
    attrs: {
      "label": "ddsss",
      "name": "allOrder"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-72d27655!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/test.vue
// module id = 333
// module chunks = 2